exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.geolocation-picker-field {\n    width: 190px;\n}\n.geolocation-picker-map {\n    height: 220px;\n    border: 1px solid #e2e8f0;\n    border-radius: 8px;\n    overflow: hidden;\n}\n", ""]);

// exports
